
import { ThumbsDown, Crown } from "lucide-react";

interface RankIconProps {
  rank: number;
  isWorst?: boolean;
}

export const RankIcon = ({ rank, isWorst }: RankIconProps) => {
  if (isWorst) {
    if (rank === 0) return <ThumbsDown className="h-4 w-4 text-red-500" />;
    if (rank === 1) return <span className="font-bold text-red-400">2</span>;
    if (rank === 2) return <span className="font-bold text-red-300">3</span>;
    return <span className="font-medium text-muted-foreground">{rank + 1}</span>;
  }
  
  if (rank === 0) return <Crown className="h-4 w-4 text-[#FFD700] fill-[#FFD700]" />;
  if (rank === 1) return <span className="font-bold text-[#C0C0C0]">2</span>;
  if (rank === 2) return <span className="font-bold text-[#CD7F32]">3</span>;
  return <span className="font-medium text-muted-foreground">{rank + 1}</span>;
};
